export default "__VITE_ASSET__D9fw9Oe7__"